import React from 'react'
import { StyleSheet, Text, TouchableOpacity } from 'react-native'
import { corporateColor } from '../../../theme/colors'
import { DOBRA } from '../../../theme/fonts'
interface Props {
  word: string
  onPress: () => void
}

export const OptionsItem = ({ onPress, word }: Props) => {
  return (
    <TouchableOpacity onPress={onPress} style={styles.containerItem}>
      <Text style={styles.textItem}>{word}</Text>
    </TouchableOpacity>
  )
}
const styles = StyleSheet.create({
  containerItem: {
    alignItems: 'center',
  },
  textItem: {
    fontFamily: DOBRA,
    fontSize: 14,
    color: corporateColor,
    padding: 15,
  },
})
